import React from "react";
import {StateOptions, Tabs} from "gd-react";
import "./MainSitePage.scss";
import TabbedPage from "../../components/TabbedPage/TabbedPage";
import MainSitePage from "./MainSitePage";
import MobileSiteAssetListPage from "./MobileSiteAssetListPage";
import MobileDataPage from "../data/MobileDataPage";
import SiteSettingsGateways from "./SiteSettingsGateways";
import MobileSiteSettingsGateways from "./MobileSiteSettingsGateways";
import DesktopDataPage from "../data/DesktopDataPage";

class DesktopMainSitePage extends MainSitePage {
	render() {
		let self = this;
		let dataTabs = [];
		if (this.state.site && this.state.assets) {
			this.state.assets.forEach(function (asset) {
				let stateOptions = StateOptions.find(t => t.type === asset.sku);
				if (!stateOptions) {
					stateOptions = StateOptions.find(t => t.type === 'default');
				}
				let dataIndex = 0;
				if (stateOptions) {
					stateOptions.dataTypes
						.filter(dT => !dT.downloadOnly)
						.forEach(function (dataType) {

						let tabObj = {
							default: dataTabs.length === 0,
							url: dataType.type.toLowerCase(),
							title: dataType.category,
							dataType: dataType,
							priority: dataType.category === 'Electricity' ? 10 : dataType.category === 'Gas' ? 9 : dataType.category === 'Water' ? 8 : 0,
							component: MobileDataPage
						};

						if (dataType.category !== 'Signal' && (!dataTabs.find(dT => dT.title === dataType.category)) && (dataType.type.toLowerCase().indexOf('spend') === -1)) {
							dataTabs.push(tabObj)
						}

					})
				}
			})
		}
		dataTabs.sort((dTA,dTB) => dTB.priority - dTA.priority);
		let tabs = [
			{
				url: 'data',
				title: 'Data',
				tabs: dataTabs
			},
			{
				default: true,
				url: 'devices',
				title: 'Devices',
				component: MobileSiteAssetListPage
			},
			{
				url: 'hubs',
				title: (<div>Hubs{this.state.hubs && this.state.hubs.list.filter(h => h.disconnected).length > 0 ? (<span
					className={'gateway-warnings'}>{this.state.hubs.list.filter(h => h.disconnected).length}</span>) : ''}
				</div>),
				component: MobileSiteSettingsGateways
			},];
		let {siteId} = this.props.match.params;

		return (
			<TabbedPage isMobile={true}
						dataLoaded={(this.state.site)}
						className={"site-page"}
						tabs={tabs} item={this.state.site}
						filterType={'site_id'}
						filterId={siteId}
						type={'site'}
						availableDataTypes={this.state.availableDataTypes}
						dataItems={this.state.assets}
						hubs={this.state.hubs}
						{...this.props}/>
		)
	}
}

export default DesktopMainSitePage;

